import axios, { AxiosResponse } from "axios";

const formMetaInfo = {
  getAuditFormMetaInfo: (orgId: number): Promise<AxiosResponse> =>
    axios.get(`/api/v1/form-metainfo/organization/${orgId}`),
};

export default formMetaInfo;
